import { observable, set } from 'mobx';

export interface IAsset {
    src: string;
    alt: string;
    assetType?: string;
}

export class Asset {
    @observable public src: string = '';
    @observable public alt: string = '';
    @observable public assetType?: string = '';

    public static fromJson(asset?: IAsset): Asset {
        const newAsset = new Asset();
        if (asset) {
            set(newAsset, asset);
        }

        return newAsset;
    }
}
